import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Row, Col, Typography, Tabs, message, Spin, Checkbox , Grid} from "antd";
import { genericApiCall, spacerData } from "./CommonApiCallCalender";
import useDebounce from "../Common/useDebounce";
import { ArrowLeftOutlined, ArrowRightOutlined, DownOutlined } from "@ant-design/icons";
import { ColorCode } from "../Common/ColorCode";
import './AppointmentSelection.css'
import moment from "moment";
import ClinicMap from "./ClinicMap";
import SlotCountdownInline from "../Alerts/SlotCountdown";


const AppointmentSelection = (props) => {
    // console.log('::::::propsAppointmentSelection  :::::::',props.showAppoinmentData.selectedSlots props.showAppoinmentData)
    const [selectedSlot, setSelectedSlot] = useState([]);
    const [showAllSlotsByApi, setshowAllSlotsByApi] = useState([]);
    const [selectedClinics, setselectedClinics] = useState([]);
      const [checkedNP, setCheckedNP] = useState(false);
      const [checkedEP, setCheckedEP] = useState(false);
    const [loading, setloading] = useState(false);
    const debouncedInputValue = useDebounce(selectedClinics, 800);
    const [messageApi, contextHolder] = message.useMessage();
  // Ref to remember last payload we requested to avoid duplicate requests
  const lastCalledPayloadRef = useRef(null);
  // Track inflight requests to avoid parallel duplicate API calls
  const inflightRequestsRef = useRef(new Set());
     let length=0
    const bottomRef = useRef(null);
    const { useBreakpoint } = Grid;
            const screens = useBreakpoint();
    useEffect(() => {
        // console.log('::::::useEffect :::::::', props.showAppoinmentData.clinic.productCategory)
        if (props?.showAppoinmentData?.selectedSlots && props?.showAppoinmentData?.selectedClinics) {
            let payloadData = []
            props.showAppoinmentData?.selectedClinics.map(id => {
                // console.log('id::', id)
                props?.showAppoinmentData?.selectedSlots.map(data => {
                    // console.log('data::', data)
                    if (data && id && id && data.start_time) {
                        // data.clinic_id.map((clinicId, i) => {
                        payloadData.push({
                            end_time: data.end_time,
                            start_time: data.start_time,
                            clinic_id: id, //clinicId,
                            date: data.date
                        })
                        // })
                    }
                })

            })
            // console.log('payloadData::', payloadData)
            if (payloadData && payloadData.length) {
                setselectedClinics(payloadData)
            }
        }

    }, [props.showAppoinmentData])

  useEffect(() => {
    // Only call API when debounced value changes and is different from last requested payload
    if (debouncedInputValue) {
      // Ensure payload is { data: [...] } when debouncedInputValue is an array
      let payload;
      if (Array.isArray(debouncedInputValue)) {
        payload = { data: debouncedInputValue.slice() };
      } else {
        // fallback: wrap single item into data array
        payload = { data: [debouncedInputValue] };
      }

      payload.duration_id = props?.showAppoinmentData?.duration;
      payload.product_category_id = props.showAppoinmentData.clinic?.productCategory?.product_category_id;

      let key;
      try {
        key = JSON.stringify(payload);
      } catch (e) {
        // fallback: use timestamp (will not dedupe)
        key = String(Date.now());
      }

      // don't call API if any data item is missing start_time or end_time
      const hasCompleteTimes = Array.isArray(payload.data) && payload.data.length > 0 && payload.data.every(item => item && item.start_time && item.end_time);
      if (!hasCompleteTimes) {
        // Do not set lastCalledPayloadRef so later updates with times will trigger the call
        return;
      }

      if (lastCalledPayloadRef.current === key) {
        // same payload as last call - skip
        return;
      }

      lastCalledPayloadRef.current = key;
      getAllAvailableSlot(payload);
    }

  }, [debouncedInputValue]);

      const handleChangeForNp = (e) => {
    setCheckedNP(e.target.checked);
    setCheckedEP(false)
    // console.log(`checked = ${e.target.checked}`);
  };
      const handleChangeForEP = (e) => {
    setCheckedEP(e.target.checked);
    setCheckedNP(false)
    // console.log(`checked = ${e.target.checked}`);
  };
    const getAllAvailableSlot = async (clinicId) => {
    // dedupe by payload key to avoid multiple identical calls
    let key;
    try {
      key = JSON.stringify(clinicId);
    } catch (e) {
      key = String(Math.random());
    }

    if (inflightRequestsRef.current.has(key)) {
      // a request with this payload is already in-flight
      return;
    }
    inflightRequestsRef.current.add(key);
    setloading(true);
        console.log('product_category_id :::', props.showAppoinmentData.clinic?.productCategory?.product_category_id)
    // clinicId is expected to already be a payload-shaped object: { data: [...], duration_id, product_category_id }
    // normalize into payload we will pass to spacerData
    const payload = typeof clinicId === 'object' && clinicId !== null && clinicId.data ? { ...clinicId } : { data: Array.isArray(clinicId) ? clinicId.slice() : [clinicId] };
    payload.duration_id = props?.showAppoinmentData?.duration || payload.duration_id || null;
    payload.product_category_id = props.showAppoinmentData.clinic?.productCategory?.product_category_id || payload.product_category_id || 1;

    if (props.showAppoinmentData.clinic?.productCategory?.product_category_id == 2) {
      payload.product_id = props.showAppoinmentData.clinic.non_gp_product_id ?? payload.product_id ?? null;
      payload.product_category_id = props.showAppoinmentData.clinic?.productCategory?.product_category_id;
    }

    if (props.showAppoinmentData.clinic?.isReshedula && props.showAppoinmentData.clinic.calenderData) {
      payload.appointment_id = props.showAppoinmentData.clinic.calenderData.appointment_id ?? payload.appointment_id ?? 1;
    }

    if (props.showAppoinmentData.clinic?.productCategory?.product_category_id == 1) {
      payload.duration_id = props.showAppoinmentData.duration ?? payload.duration_id ?? 1;
      const langVal = props?.showAppoinmentData?.language?.value || props?.showAppoinmentData?.language;
      payload.languages = Array.isArray(payload.languages) ? payload.languages : (langVal ? [langVal] : []);
      payload.product_category_id = props.showAppoinmentData.clinic?.productCategory?.product_category_id;
    }

    // console.log('payload :::', payload)
        // return

        let csrRoomData
    if(props?.data?.isProtected === false ){
      // console.log(`availabe_slots-ProductCatId ${props.showAppoinmentData.clinic?.productCategory?.product_category_id} : `, payload)
      csrRoomData = await spacerData('available-slots', payload, null, false)
        }else {
            // csrRoomData = await spacerData('available-slots', data,  null, false)
        }

        // console.log('::::::csrRoomData available-slots :::::::', csrRoomData.data?.data)
        // let datatempnew = transformClinicData(csrRoomData.data.data)
        // console.log('::::::`datatempnew datatempnew :`::::::', csrRoomData)
    try {
      if (csrRoomData?.data?.data) {
        setshowAllSlotsByApi(csrRoomData.data.data);
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
      } else {
        setshowAllSlotsByApi([]);
      }
    } finally {
      inflightRequestsRef.current.delete(key);
      setloading(false);
    }
    }
    function transformClinicData(data) {
        const result = [];

        const formatDateKey = (dateStr) => {
            const date = new Date(dateStr);
            const options = { weekday: 'short', day: '2-digit', month: 'short' };
            return date.toLocaleDateString('en-GB', options).toUpperCase(); // "TUE, 14 JAN"
        };

        const clinicMap = {}; // To avoid duplicate clinic entries

        Object.entries(data).forEach(([dateStr, slots]) => {
            const formattedDate = formatDateKey(dateStr);

            slots.forEach(slot => {
                const time = slot.start_time;

                slot.available_clinics.forEach(clinic => {
                    const key = clinic.id; // you can use clinic.id for uniqueness

                    if (!clinicMap[key]) {
                        clinicMap[key] = {
                            name: clinic.name,
                            address: "N/A", // Replace with actual address if available
                            id: clinic.id,
                            times: {}
                        };
                    }

                    if (!clinicMap[key].times[formattedDate]) {
                        clinicMap[key].times[formattedDate] = [];
                    }

                    clinicMap[key].times[formattedDate].push(time);
                });
            });
        });

        return Object.values(clinicMap);
    }

    // const handleDateSlotClick = (date, bookingData, time, clinicData) => {
    //     // console.log('::::::handleDateSlotClick :::::::', date, bookingData, time, clinicData)
    //     setSelectedSlot((prev) => {
    //         if (prev && prev.slot && prev.slot == date) {
    //             return {}
    //         } else {
    //             if (prev.length >= 1) {
    //                 messageApi.error({
    //                     type: 'error',
    //                     content: 'You can only one options.',
    //                 });
    //                 // console.log('::::::You can only one options :::::::', prev)
    //                 return prev;
    //             } else {
    //                 console.log(':loading:::', date)
    //                 return {
    //                     info: {
    //                         ...time
    //                     },
    //                     'date': bookingData,
    //                     slot: date,
    //                     clinicData

    //                 }
    //             }
    //         }
    //     });
    // }


    // 🔹 Update handleDateSlotClick to block the slot immediately
const handleDateSlotClick = async (date, bookingData, time, clinicData) => {
  if (selectedSlot?.slot === date) {
    // Unselect if same slot is clicked
    setSelectedSlot({});
    return;
  }

  const newSelectedSlot = {
    info: { ...time },
    date: bookingData,
    slot: date,
    clinicData,
  };

  const payload = buildBlockSlotPayload(
    newSelectedSlot,
    props?.showAppoinmentData?.clinic,
    props?.showAppoinmentData?.clinic?.productCategory?.product_category_id
  );

  // 🔹 Attach session_id if exists
  const existingSession = localStorage.getItem("bookingSessionId");
  if (existingSession) {
    payload.session_id = existingSession;
  }

  // setloading(true);
  try {
    const res = await genericApiCall("block-slot", payload);
    const session_id = res.data?.data?.session_id;
    const expires_at = res.data?.data?.expires_at;

    if (session_id) {
      localStorage.setItem("bookingSessionId", session_id);
      localStorage.setItem("bookingExpiresAt", expires_at);
    }

    setSelectedSlot(newSelectedSlot);
  } catch (err) {
    messageApi.error({ content: err.message || "Unable to block the slot." });
  } finally {
    setloading(false);
  }
};
    const buildBlockSlotPayload = (slot, clinic, productCategoryId) => {
    const isHS = productCategoryId === 2;
        return {
            clinic_id: slot?.clinicData?.id,

            start_time: moment(`${slot.date} ${slot.info.start_time}`, 'ddd, DD MMM HH:mm').format('YYYY-MM-DD HH:mm'),
            end_time: moment(`${slot.date} ${slot.info.end_time}`, 'ddd, DD MMM HH:mm').format('YYYY-MM-DD HH:mm'),
            product_category_id: productCategoryId,
            ...(isHS && { product_id: Number(clinic?.non_gp_product_id) }),
            session_id: localStorage.getItem('bookingSessionId') || undefined
        };
    };
    // const handleContinueButton =async () => {
    //     // if (selectedSlot && selectedSlot.info) {
    //     //     props.callback(selectedSlot, 'AppointmentSelection')
    //     // } else {
    //     //     messageApi.error({
    //     //         type: 'error',
    //     //         content: 'Select slot first.',
    //     //     })
    //     // }
    //      if (!selectedSlot || !selectedSlot.info) {
    //         messageApi.error({ content: 'Select slot first.' });
    //         return;
    //     }
    //       const payload = buildBlockSlotPayload(
    //         selectedSlot,
    //         props?.showAppoinmentData?.clinic,
    //         props?.showAppoinmentData?.clinic?.productCategory?.product_category_id
    //     );
    //     setloading(true);
    //     try {

    //         console.log("buildBlockSlotPayload-payload",payload)
    //         const res =  await genericApiCall('block-slot', payload)

    //         console.log("buildBlockSlotPayload-blockedSlot-res", res.data)

    //         const  session_id = res.data?.data?.session_id
    //         const  expires_at = res.data?.data?.expires_at
    //         localStorage.setItem('bookingSessionId', session_id);
    //         localStorage.setItem('bookingExpiresAt', expires_at);

    //         // Move to next step
    //         props.callback(selectedSlot, 'AppointmentSelection');
    //     } catch (err) {
    //         messageApi.error({ content: err.message || 'Unable to block the slot.' });
    //     } finally {
    //         setloading(false);
    //     }
    // }


    // 🔹 Simplify Continue button – no API call here


    const handleContinueButton = () => {
  if (!selectedSlot || !selectedSlot.info) {
    messageApi.error({ content: "Select slot first." });
    return;
  }
  props.callback(selectedSlot, "AppointmentSelection");
};


        function persentage(index){
                const uniqueClinicIds = showAllSlotsByApi[index - 1]?.times?.length;
                const totalExpectedTimeSlots=uniqueClinicIds*8
                // console.log("showAllSlotsByApi",showAllSlotsByApi[index-1]);

                const allSlots=showAllSlotsByApi?.times

                const totalSlota1=showAllSlotsByApi[index-1]?.times?.[0]
                const totalSlota2=showAllSlotsByApi[index-1]?.times?.[1]
                const totalSlota3=showAllSlotsByApi[index-1]?.times?.[2]

                const first =totalSlota1 ? Object.values(totalSlota1)[0] :[];
                const second =totalSlota2 ? Object.values(totalSlota2)[0]:[];
                const third =totalSlota3 ? Object.values(totalSlota3)[0]:[];


                const length1 = first?.length;
                const length2 = second?.length;
                const length3 = third?.length;
                // console.log("length,,,,",length1,"and ",length2 ,"and ",length3);

                let totalSlotas =0
                totalSlotas=length1 +length2 +length3
                // console.log("total slots",totalSlotas, "and total expected",totalExpectedTimeSlots);
                // console.log("percentage",totalSlotas/totalExpectedTimeSlots*100);
                return totalSlotas/totalExpectedTimeSlots*100 || 0
    }

                          //  console.log("data outside the component",showAllSlotsByApi);

  const sortedClinics = showAllSlotsByApi.map(clinic => {
    const sortedTimes = [...clinic.times].sort((a, b) => {
        const dateA = new Date(Object.keys(a)[0] + ' 2025');
        const dateB = new Date(Object.keys(b)[0] + ' 2025');
        return dateA - dateB;
    });

    return {
        ...clinic,
        times: sortedTimes
    };
});

    return (
        <div style={{ backgroundColor: '#fff' ,paddingLeft:"10px",paddingRight:"10px"}} ref={bottomRef}>
          <div style={{ color: "black", margin: 0, fontSize: "20px", marginLeft: "auto", display: 'flex', alignItems: 'center' }}>
                   
                   
                                   <SlotCountdownInline />
                    <div style={{ color: "black", margin:" 0 0 0 10px ", fontSize: "20px", marginLeft: "auto", fontWeight: 'bold' }}>
                                 {/* <SlotCountdown expiresAt={localStorage.getItem('bookingExpiresAt')} /> here render  */}

                        {/* Hi,<span style={{ fontSize: "20px", fontWeight: 'normal' }}> {userData?.name} </span> */}
                    </div>                    
                </div>
            {contextHolder}
            {sortedClinics && loading == false && sortedClinics.length ? sortedClinics?.map((data, i) => {
                const stopPercent = i === 0 ? persentage(1) : i === 1 ? persentage(2) : persentage(3);
                return (
                    <div>
                        <hr style={{
                            border: "none",
                            height: "12px",
                            background: `
                                        linear-gradient(
                                            to right,
                                            #008385 0%,
                                            #008385 ${stopPercent}%,
                                            #00838580 ${stopPercent}%,
                                            #00838580 100%
                                        )
                                        `,
                        }} />
                        <Row style={{ alignItems: 'start',margin:"0px",rowGap:"0px" }} gutter={[16, 16]} >
                            <Col xs={{ span: 24 }}
                                sm={{ span: 24 }}
                                md={{ span: 10 }}
                                lg={{ span: 8 }}
                                xl={{ span: 6 }}
                                xxl={{ span: 6 }}
                            >
                              {/* Heightchange 100px to removed from here */}
                                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'start',paddingTop:"20px" ,}}>
                                    <div style={{ width: 90, height: 90, borderRadius: "10px", marginLeft: 10,color:"#008385" }}>
                                        {/* <iframe
                                            width={90}
                                            height={90}
                                            style={{ border: "0", marginTop: 0 }}
                                            loading="lazy"
                                            // allowFullScreen
                                            src={`https://www.openstreetmap.org/export/embed.html?bbox=${props?.data?.clinic?.longitude},${props?.data?.clinic?.latitude},${props?.data?.clinic?.longitude},${props?.data?.clinic?.latitude}&layer=mapnik`}
                                        ></iframe> */}
                                        <ClinicMap widthAndheight={{ width: 100, height: 100, }} passData={{
                                            cood: [{
                                                id: props.data.allClinicDataByID[data.id]?.id,
                                                name: props.data.allClinicDataByID[data.id]?.name,
                                                data: [props.data.allClinicDataByID[data.id]?.latitude, props.data.allClinicDataByID[data.id]?.longitude]
                                            }], name: props.data.allClinicDataByID[data.id]?.name ?? 'No data'
                                        }} />
                                    </div>
                                    <div style={{ width: "auto", textAlign: 'left', marginLeft: 30 ,color:"#000",
                                      // fontFamily:"Lato",
                                      }} className="font">
                                        <h3 style={{fontSize:"16px", fontWeight:"500", marginBlock:"10px",margin:"0px"}}>{data && data.name ? data.name : ''}</h3>
                                        <p style={{fontSize:"14px", fontWeight:"400", marginBlock:0, marginBottom:5}}>{data && data.id && props?.data && props.data.allClinicDataByID && props.data.allClinicDataByID[data.id] ? props.data.allClinicDataByID[data.id].address : ''}</p>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={{ span: 24 }}
                                sm={{ span: 24 }}
                                md={{ span: 14 }}
                                lg={{ span: 16 }}
                                xl={{ span: 18 }}
                                xxl={{ span: 18 }}
                                style={{paddingLeft:"18px"}}>
                                <div style={{ display: 'grid'}} className="custom-scroll">
                                    {data && data.times && data.times.length ? data.times.map((date,index) => {
                                        return <>
                                            {Object.keys(date).map((key, i) => {
                                                const year = 2025;
                                                const dateNew = moment(`${key} ${year}`, 'ddd, DD MMM YYYY');
                                                const day = dateNew.day();
                                                const isWeekend = day === 0 || day === 6;
                                                 if (length <date[key]?.length) {
        length = date[key]?.length
    }
                                                return <>
                                                    <div style={{ display: 'flex',alignItems:index===0?"start":"start",position:"relative" ,marginTop:index===0?"0":"0px"}} className="">
                                                        <div style={{position: "relative", display: "flex", alignItems: "start", paddingTop:index===0?"25px":"0px"}} >
                                                        <div className={  `${index === 0 ? "appointmentStartTime" : ""} ${date[key]?.length === 0 ? "noSlots" : ""}`}style={{paddingTop:index===0?"0px":"0px",position:"sticky",left:"0px",backgroundColor:"white",paddingRight:"10px",paddingBottom:"0px",backgroundColor: '#fff', borderRight: `${screens.md ?'1px solid #008385' : '1px solid #008385'}`}}>
                                                            {/* removed hegith in key 20.1 */}
                                                            <div style={{ backgroundColor: '#fff', border: '1px solid #008385',  padding: 3, width: 94.9 , }}>{key }</div>
                                                        </div>
                                                        <div style={{display:"flex",flexDirection:"column",justifyContent:"start",alignItems:"start",paddingTop:index===0?"1px":"1px"}}>
                                                            {/* <div style={{ border : "1px solid #ff5f1f"}}></div> */}
                                                            {/* <div style={{height:30, width : 10 , background: "red",position:"absolute", left:-1 }}  /> */}
                                                            {/* { index===0 && <div  className={`${screens.md?"":"appointment-label"}`} style={{  marginBottom: 15 ,paddingLeft:"0",position:"sticky",left:"122px"}}>:</div>} */}
                                                        <div style={{ display: 'flex', marginBottom: "10px",minWidth:`${length==0?"720":length*90}px`,minHeight:"40px"}} className=""  >

                                                            {
  (() => {

   
    const minSlots = length;
    // console.log(':::minSlots:::',date[key],key);
    const hasSlots = date[key] && date[key].length > 0;
    var slots = hasSlots ? [...date[key]] : [];

    if ( !(checkedEP || checkedNP)) {
      if (hasSlots && slots.length < minSlots) {
        while (slots.length < minSlots) {
          slots?.push(null); // Push placeholder
        }
      }
    }
    else {
    slots = hasSlots ? [...date[key]] : [];
    }

    if (!hasSlots) {
      return (
        <div style={{ marginLeft: 15, color: ColorCode.red, height: '40px' ,textAlign:"left"}}>
           
        </div>
      );
    }

    return slots?.map((time, index) => {
      const isValidSlot = time !== null;
      const time1 = moment(time?.evening_start_time ?? '18:00', "HH:mm");
      const time2 = moment(time?.start_time, "HH:mm");
      const isLargeScreen = screens?.md;
      return (
        <div
          key={index}
          style={{
            maxHeight: '200px',
            // display: 'flex',
            display:!checkedEP && !checkedNP ? 'flex':checkedEP ? (isWeekend || (time1.isBefore(time2) || time1.isSame(time2)))   ? 'flex': 'none': checkedNP ? !(isWeekend || (time1.isBefore(time2) || time1.isSame(time2))) ? 'flex': 'none' : 'flex',
            flexDirection: 'column',
            minWidth: '90px',
            flexShrink: 0,
          }}
        >
          {!isValidSlot ? (
            <div
              style={{
                width: 76,
                height: 24,
                marginLeft: isLargeScreen ? 10 : 10,
                marginBottom: 15,
                visibility: 'hidden', // preserve layout spacing but hide placeholder
              }}
            />
          ) : !checkedEP && !checkedNP ? (
            <div
              className={
                selectedSlot?.slot === `${data.id}${key}${time.start_time}`
                  ? 'appointment-select-time-selected'
                  : 'appointment-select-time'
              }
              style={{

                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                border: '1px solid #008385',
                borderRadius: 20,
                                                                            cursor:"pointer",
                width: 76,
                height: 21.5,
                                                                            // marginLeft: `{${date[key].length > 1 ? 14 : 0}}px`,
                                                                            // marginLeft: index === 0  ? 10 : 14,
                marginLeft: isLargeScreen ? 10 : (index === 0 ? 10 : 10),
                backgroundColor:
                  props?.showAppoinmentData?.clinic?.productCategory?.product_category_id === 2
                    ? selectedSlot?.slot === `${data.id}${key}${time.start_time}`
                      ? '#008385'
                      : '#fff'
                    : selectedSlot?.slot === `${data.id}${key}${time.start_time}`
                    ? '#008385'
                    : isWeekend
                    ? '#00838540'
                    : time1.isBefore(time2) || time1.isSame(time2)
                    ? '#00838540'
                    : '#fff',
                color: selectedSlot?.slot == `${data.id}${key}${time.start_time}` ? '#fff' : '#4a4a4a',
                                                                            marginBottom:15
              }}
              onClick={() => handleDateSlotClick(`${data.id}${key}${time.start_time}`, key, time, data)}>
              {time.start_time}
            </div>
          ) : checkedEP ? (
            
            (isWeekend || (time1.isBefore(time2) || time1.isSame(time2))) ? (
              <div
                className={
                  selectedSlot?.slot === `${data.id}${key}${time.start_time}`
                    ? 'appointment-select-time-selected'
                    : 'appointment-select-time'
                }
                style={{

                 display: !time.start_time.length>0?"none": 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  border: '1px solid #008385',
                  borderRadius: 20,
                                                                            cursor:"pointer",
                  width: 76,
                  height: 24.5,
                  marginLeft: 14,
                  backgroundColor:
                    props?.showAppoinmentData?.clinic?.productCategory?.product_category_id === 2
                      ? selectedSlot?.slot === `${data.id}${key}${time.start_time}`
                        ? '#008385'
                        : '#fff'
                      : selectedSlot?.slot === `${data.id}${key}${time.start_time}`
                      ? '#008385'
                      : isWeekend
                      ? '#00838540'
                      : time1.isBefore(time2) || time1.isSame(time2)
                      ? '#00838540'
                      : '#fff',
                  color:
                    selectedSlot?.slot === `${data.id}${key}${time.start_time}`
                      ? '#fff'
                      : '#4a4a4a',
                  marginBottom:15
                }}
                onClick={() =>
                  handleDateSlotClick(`${data.id}${key}${time.start_time}`, key, time, data)
                }
              >
                {time.start_time}
              </div>
            ) : (
              <div style={{ width: 'max-content', height: '41px', color: 'red',backgroundColor:"red" }} />
            )
          ) : !(isWeekend || time1.isBefore(time2) || time1.isSame(time2)) ? (
            <div
              className={
                selectedSlot?.slot === `${data.id}${key}${time.start_time}`
                  ? 'appointment-select-time-selected'
                  : 'appointment-select-time'
              }
              style={{

                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                border: '1px solid #008385',
                borderRadius: 20,
                                                                            cursor:"pointer",
                width: 76,
                height: 24.5,
                marginLeft: 14,
                backgroundColor:
                  props?.showAppoinmentData?.clinic?.productCategory?.product_category_id === 2
                    ? selectedSlot?.slot === `${data.id}${key}${time.start_time}`
                      ? '#008385'
                      : '#fff'
                    : selectedSlot?.slot === `${data.id}${key}${time.start_time}`
                    ? '#008385'
                    : isWeekend
                    ? '#00838540'
                    : time1.isBefore(time2) || time1.isSame(time2)
                    ? '#00838540'
                    : '#fff',
                color:
                  selectedSlot?.slot === `${data.id}${key}${time.start_time}`
                    ? '#fff'
                    : '#4a4a4a',
                marginBottom: 15,
              }}
              onClick={() => handleDateSlotClick(`${data.id}${key}${time.start_time}`, key, time, data)}>
              {time.start_time}
            </div>
          ) : (
            <div style={{ width: 'max-content', height: '41px', color: 'red' }} />
          )}
        </div>
      );
    });
  })()
}

                                                        </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </>
                                            })}
                                        </>
                                    }) : <div style={{ display: 'flex',alignItems:"center", marginBottom: 10, color: ColorCode.red ,height:"40px"}}> No slots are available for this clinic.</div>}
                                </div>
                            </Col>
                        </Row>
                    </div>
                )
            }) : loading ? <Spin className="custom-spinner" /> : ''}
            <hr />

            {showAllSlotsByApi && showAllSlotsByApi.length ? <>
                <div style={{ display: "flex", justifyContent: 'center',margin:"20px auto",flexDirection:screens.md?"row":"column",width:screens.md?"100%":"185px" }}>

                    { props?.showAppoinmentData?.clinic?.productCategory?.product_category_id !== 2 &&(<><div style={{ display: "flex", marginRight: 10 }}>
                        <div className="flex items-center space-x-2" style={{ gap: '10px', }}>
                            <Checkbox
                                checked={checkedNP}
                                onChange={handleChangeForNp}
                                className="custom-ant-checkbox"
                            />
                        <span className="label-text">Regular price</span>
                            </div>
                    </div>
                    <div style={{ display: "flex", }}>
                        <div className="flex items-center space-x-2" style={{ gap: '10px' }}>
                            <Checkbox 
                                checked={checkedEP}
                                onChange={handleChangeForEP}
                                className="custom-ant-checkbox EviningPrice"
                            />
                            <span className="label-text">Evening or weekend price</span>
                            </div>
                    </div></>)}
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 50 ,position:"relative"}}>
                    <Button
                        shape="square"
                        icon={<ArrowLeftOutlined style={{ color: '#008385', fontSize: '18px' }} />}
                        style={{
                            backgroundColor: '#C8E6E6', // Light teal
                            border: 'none',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: 0,
                            marginRight: 10,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            position:"absolute",
                            left:"0px"
                        }}
                        onClick={() => {props?.callBackForbackpage('BookingForm') ; setshowAllSlotsByApi([])} }
                    />
                    <Button onClick={()=>{handleContinueButton () ;}} type="primary" style={{ background: "#008385", border: "none",height:"40px",width:"182px",
                      // fontFamily:'lato',
                      fontWeight:"400",borderRadius:"10px" }}>
                        Continue
                    </Button>
                </div>
            </> : ''
            }
        </div>
    );
};

export default AppointmentSelection;
